import ms from "ms";

export const DEFAULT_STALE_TIME = ms("5 minutes");
export const DEFAULT_CACHE_TIME = ms("1 hour");
export const DEFAULT_POLLING_INTERVAL = ms("3 minutes");
